export const RESIDENCE_STATUS_OPTIONS = [
    "特定技能1号",
    "特定技能2号",
    "家族滞在",
    "留学",
    "特定活動",
    "海外滞在",
    "技人文"
];
